import React, { FC } from 'react';
import { PopoverFactoryRenderer } from '../../components/popovers/PopoverFactoryRenderer';
import { LawFirm } from '../../enterprise/enterprise.types';
import { LawFirmPopover } from '../../law-firm/popover/LawFirmPopover';
import {
  EntityListItem,
  EntityListIcon,
  EntityListGroup,
} from './components/EntityListComponents';
import { EntityListSubtitle } from './components/subtitle/EntityListSubtitle';
import { EntityListLinkTitle } from './components/title/EntitlyListLinkTitle';

type Props = {
  lawFirms: Array<LawFirm>;
  source: string;
  wording: string;
  handleClickDecision: Function;
  fromModal?: boolean;
};

export const LawFirmList: FC<Props> = ({
  source,
  lawFirms,
  wording,
  handleClickDecision,
  fromModal = false,
}) => {
  const displayPopover = (element: HTMLElement) => {
    const lawOfficeIdGroup = element.getAttribute('data-law-firm');
    if (lawOfficeIdGroup) {
      return (
        <LawFirmPopover
          source={`${source}_popover`}
          lawOfficeIdGroup={lawOfficeIdGroup}
        />
      );
    }
  };

  return (
    <PopoverFactoryRenderer
      renderTemplate={displayPopover}
      isPopoverInsideModal={fromModal}
    >
      {lawFirms.map(firm => (
        <EntityListItem key={firm.url}>
          <EntityListIcon
            src="/img/icons/entities/law-firm.svg"
            alt="law-firm-icon"
          />
          <EntityListGroup>
            <EntityListLinkTitle
              source={source}
              entityId={firm.lawOfficeIdGroup}
              entityUrl={firm.url}
              entityName={firm.nom}
            />
            <br />
            <EntityListSubtitle
              wording={wording}
              handleClickDecision={handleClickDecision}
              entity={firm}
            />
          </EntityListGroup>
        </EntityListItem>
      ))}
    </PopoverFactoryRenderer>
  );
};
